import { Badge } from "@similarweb/ui-components";

export const LegacyBadge = () => {
    return <Badge type="neutral">Legacy</Badge>;
};
